export default __webpack_public_path__ + "images/2755664512c0cf61cfafa225f700d7c7.png";